<template>
  <div>
    <LoadingSpinner :visible="isLoading" />
    <!----------------- Main contents Area --------------------->
    <main class="mt-3">
      <div class="pl-1 text-center coupon-page">
        <div class="alert alert-info" role="alert">
          <b class="fs-4">쿠 폰 생 성 & 리 스 트</b>
        </div>
        <div class="float-start mb-2">
          <span class="fs-6 fw-bold text-primary">[ 쿠 폰 생 성 ]</span>
          <span>
            쿠폰번호: <span style="color: red; font-weight: 600;">{{ this.cpCode }}</span> / 발행수량:&nbsp;
            <span v-if="this.firstQty == 0">관리X</span>
            <span v-else-if="this.firstQty > 0" class="text-success">{{ this.firstQty }}</span>
            <span v-else-if="this.firstQty < 0">수량체크가 필요합니다!</span>
          </span>&nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-success btn-sm" style="font-size: small;" @click="pageReload">초기화</button>
        </div>

        <!-- make coupon area -->
        <div class="section-card">
          <span class="section-label">쿠폰 생성</span>
          <table class="table table-bordered">
            <thead>
              <tr style="background-color: lightgray;">
                <th style="font-size: 1rem; font-weight: 600; width:10%;">1. 쿠폰상태</th>
                <th style="font-size: 1rem; font-weight: 600; width:10%;">2. 적용대상</th>
                <th style="font-size: 1rem; font-weight: 600; width:10%;">3. 발행대상</th>
                <th style="font-size: 1rem; font-weight: 600; width:20%;">4. 쿠폰명</th>
                <th style="font-size: 1rem; font-weight: 600; width:10%;">5. 적용금액</th>
                <th style="font-size: 1rem; font-weight: 600; width:5%;">6. 수량</th>
                <th style="font-size: 1rem; font-weight: 600; width:8%;">7. 발행일자</th>
                <th style="font-size: 1rem; font-weight: 600; width:8%;">8. 사용기한</th>
                <th style="font-size: 1rem; font-weight: 600; width:8%;">9. 발행자</th>
                <th style="font-size: 1rem; font-weight: 600; width:15%;">10. 필수확인사항</th>
                <th style="font-size: 1rem; font-weight: 600; width:5%;">11. 생성</th>
              </tr>
            </thead>
            <tbody>
              <tr style="vertical-align: middle;">
                <td>
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_cpActive" v-model="this.cpActive">
                    <option value="active">활성쿠폰 (즉시사용가능)</option>
                    <option value="inactive">비활성쿠폰 (등록 후 사용가능)</option>
                  </select>
                </td>
                <td>
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_cpUseCode" v-model="this.cpUseCode" @change="show_cpUseCodeList(this.cpUseCode, '')">
                    <option value="AL">전체상품</option>
                    <option value="CA">특정카테고리</option>
                    <option value="PD">특정상품</option>
                  </select>
                </td>
                <td>
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_cpType" v-model="this.cpType" @change="show_cpTypeList(this.cpType, '')" :disabled="this.cpActive === 'inactive'">
                    <option value="mAll">전체회원</option>
                    <option value="pAll">프리미엄멤버</option>
                    <option value="sAll">스탠다드멤버</option>
                    <option value="sMem">특정회원</option>
                  </select>
                </td>
                <td>
                  <input type="text" v-model="this.cpName" style="font-size:0.9rem" maxlength="40" ref="cpName" placeholder="50자 이내">
                </td>
                <td>
                  <div class="d-flex justify-content-center align-items-center">
                    <input type="number" v-model="this.cpPrice" style="font-size:0.9rem; height:28px; width:55%" maxlength="10" ref="cpPrice">
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" style="font-size:0.9rem; height:28px; width:30%;" ref="sel_cpPriceFlag" v-model="this.cpPriceFlag">
                      <option value="A" style="color:red;">원</option>
                      <option value="R" style="color:blue;">%</option>
                    </select>
                  </div>
                </td>
                <td>
                  <input type="number" v-model="this.firstQty" style="font-size:0.9rem; height:28px; width:70%" maxlength="10" ref="firstQty">
                </td>
                <td>
                  <input type="date" v-model="this.cpIssueDate" style="font-size:0.9rem;" ref="cpIssueDate">
                </td>
                <td>
                  <input type="date" v-model="this.cpExpDate" style="font-size:0.9rem;" ref="cpExpDate">
                </td>
                <td>
                  <input type="text" v-model="this.cpIssuer" style="font-size:0.9rem;" ref="cpIssuer">
                </td>
                <td>
                  <textarea class="form-control" placeholder="300자 이내" ref="cpRemarks" id="floatingTextarea" style="height:60px; font-size:0.7rem;" v-model="this.cpRemarks" maxlength="300"></textarea>
                </td>
                <td>
                  <button type="button" class="btn btn-primary btn-md" @click="makeCoupon">생성</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="section-divider"></div>

        <!-- 선택된 파라메타 stock -->
        <div class="section-card section-card--compact">
          <span class="section-label">선택된 적용대상 / 발행대상</span>
          <table id="stockTable" class="col-12">
            <tr>
              <td class="stockTable col-6">
                <div class="chips-container">
                  <span v-for="(item, idx) in selectedCpUseArray" :key="item" class="chip">
                    {{ item.name }}
                    <button type="button" class="chip-close" @click="removeCpUse(idx)"><i class="bi bi-x-circle" style="font-size: 0.8rem;"></i></button>
                  </span>
                </div>
              </td>
              <td class="stockTable col">
                <div class="chips-container">
                  <span v-for="(item, idx) in selectedcpTypeArray" :key="item" class="chip">
                    {{ item.memName }} ({{ item.memId }})
                    <button type="button" class="chip-close" @click="removeCpType(idx)"><i class="bi bi-x-circle" style="font-size: 0.8rem;"></i></button>
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="section-divider"></div>

        <div class="section-card section-card--compact">
          <span class="section-label">적용대상 / 발행대상 선택</span>
          <table style="width: 100%;">
            <tr>
              <td style="vertical-align: top; width: 50%;">
                <div v-if="this.show_cpUseCode == 'Y'">
                  <div class="mb-1 input-group" v-if="this.cpUseCode === 'PD'">
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_catCode" v-model="this.catCode" @change="changeCatCode(catCode)">
                      <option :value="noVal" disabled>상품카테고리</option>
                      <option value="A">전체보기</option>
                      <option :value="ac.baseCode" :key="i" v-for="(ac, i) in this.pdtCategoryList">{{ ac.codeNameKor }}</option>
                    </select>&nbsp;&nbsp;&nbsp;
                    <input type="text" v-model="this.keyWord_cu" style="font-size:0.9rem; background-color: beige; width: 350px;" ref="cpName" placeholder="상품명">
                    <button type="button" class="btn btn-warning btn-sm" style="font-size: smaller;" @click="searchProduct(this.keyWord_cu, 'CU', 'search')">검색</button>
                  </div>
                  <div class="text-end mb-1">
                    <button type="button" class="btn btn-outline-danger btn-sm" style="font-size: smaller;" @click="saveTemp_selItems(this.cpUseCode, 'CU')">선택저장</button>
                  </div>
                  <div class="table-scroll table-scroll--compact">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr style="background-color: lightgray; width:50%; font-size: 1rem;">
                        <th style="width:5%;">
                          <input class="form-check-input" type="checkbox" style="width: 15px;" v-model="this.allSelected" @change="allChoice('CU')" />
                        </th>
                        <th style="font-size: 1rem; font-weight: 600;" v-if="this.cpUseCode === 'CA'">카테고리</th>
                        <th style="font-size: 1rem; font-weight: 600;" v-else-if="this.cpUseCode === 'PD'">상품</th>
                      </tr>
                    </thead>
                    <tbody class="small">
                      <tr :key="i" v-for="(cu, i) in this.cpUseCodeList">
                        <td>
                          <div v-if="this.cpUseCode === 'CA'">
                            <input type="checkbox" ref="chb_Seq" class="align-baseline mt-3" style="width: 15px;" :id=i name="checkedBox" v-model="cu.checkFlag">
                          </div>
                          <div v-else-if="this.cpUseCode === 'PD'">
                            <input type="checkbox" ref="chb_Seq" class="align-baseline mt-3" style="width: 15px;" :id=i name="checkedBox" v-model="cu.checkFlag">
                          </div>
                        </td>
                        <td style="padding-left: 10px;">
                          <div class="text-start" v-if="this.cpUseCode === 'CA'">
                            <span class="fw-bold fs-6">{{ cu.codeNameKor}} ({{ cu.baseCode }})</span>
                          </div>
                          <div class="text-start" v-else-if="this.cpUseCode === 'PD'">
                            <span class="text-danger fst-italic">[{{ cu.codeNameKor }}]</span>&nbsp;&nbsp;<span class="fw-bold">{{ cu.pdtNameKor}}</span><span style="font-size:smaller; color:darkgray;">({{ cu.pdtCode }})</span>&nbsp;&nbsp;<span style="font-size:smaller; color:blue;">{{ this.getCurrencyFormat(cu.minPrice) }} ~ {{ this.getCurrencyFormat(cu.maxPrice) }}원</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </td>

              <td style="vertical-align: top; width: 50%;">
                <div class="float-start mb-2" v-if="this.show_cpType === 'Y'">
                  <div class="mb-1 input-group" v-if="this.cpType === 'sMem'">
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode" v-model="rProcCode" @change="changeProcCode(rProcCode)">
                      <option :value="noVal" disabled>회원분류</option>
                      <option value="A">전체보기</option>
                      <option value="Pre">프리미엄</option>
                      <option value="Std">스탠다드</option>
                    </select>&nbsp;&nbsp;&nbsp;
                    <input type="text" v-model="this.keyWord_ct" style="font-size:0.9rem; background-color:lightgreen; width: 350px;" ref="memName" placeholder="회원성명">
                    <button type="button" class="btn btn-success btn-sm" style="font-size: smaller;" @click="searchProduct(this.keyWord_ct, 'CT', 'search')">검색</button>
                  </div>
                  <div class="text-end mb-1" v-if="this.cpType === 'sMem'">
                    <button type="button" class="btn btn-outline-success btn-sm" style="font-size: smaller;" @click="saveTemp_selItems(this.cpType, 'CT')">선택저장</button>
                  </div>
                  <div class="table-scroll table-scroll--compact" v-if="this.cpType === 'sMem'">
                  <table class="table table-bordered table-striped fs-6 align-item-center">
                    <thead>
                      <tr style="background-color: lightgray;">
                        <th style="width:1%;">
                          <input class="form-check-input" type="checkbox" v-model="allSelected_ct" @change="allChoice('CT')" />
                        </th>
                        <th style="font-size: 1rem; font-weight: 600; width:5%;">멤버십</th>
                        <th style="font-size: 1rem; font-weight: 600; width:5%;">번호</th>
                        <th style="font-size: 1rem; font-weight: 600; width:9%;">아이디</th>
                        <th style="font-size: 1rem; font-weight: 600; width:8%;">성명</th>
                        <th style="font-size: 1rem; font-weight: 600; width:8%;">가입일</th>
                        <th style="font-size: 1rem; font-weight: 600; width:10%;">연락처/알림톡</th>
                        <th style="font-size: 1rem; font-weight: 600; width:8%;">생일</th>
                        <th style="font-size: 1rem; font-weight: 600; width:5%;">성별</th>
                        <th style="font-size: 1rem; font-weight: 600; width:6%;">포인트</th>
                        <th style="font-size: 1rem; font-weight: 600; width:15%;">비고사항</th>
                      </tr>
                    </thead>
                    <tbody class="small">
                      <tr :key="i" v-for="(m, i) in memberInfo" style="font-size:small;">
                        <td>
                          <input type="checkbox" v-model="m.checkFlag" ref="chb_Seq" class="align-baseline mt-3" :id=i name="checkedBox">
                        </td>
                        <td style="color:goldenrod" v-if="m.memLevel === 'P'">{{ m.memLv }}</td>
                        <td style="color:royalblue" v-else-if="m.memLevel === 'S'">{{ m.memLv }}</td>
                        <td style="color:royalblue" v-else></td>
                        <td>{{ m.memNo }}</td>
                        <td style="font-size: smaller">{{ m.uEmail }}</td>
                        <td>{{ m.uNickName }}</td>
                        <td v-if="m.insDate == undefined">미확인</td>
                        <td v-else class="text-secondary">{{ this.getDateFormat(m.insDate) }}</td>
                        <td>{{ m.uPhone }}<p>{{ m.alimCallC }}</p></td>
                        <td>{{ m.uBirthyear }}/{{ m.uBirthday }}</td>
                        <td>{{ m.uGender }}</td>
                        <td v-if="m.memberPoint == undefined" class="text-secondary">0</td>
                        <td v-else class="text-primary">{{ this.getCurrencyFormat(m.memberPoint) }}</td>
                        <td>{{ m.spRemarks }}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="section-divider"></div>

        <!-- 발행쿠폰리스트 -->
        <div class="section-card">
          <span class="section-label">발행 쿠폰 리스트</span>

          <div class="mb-1 d-flex align-items-center flex-wrap" style="gap: 6px;">
            <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode" v-model="this.sParam" @change="changeSearchCode(this.sParam)" style="width: 140px;">
              <option value="" disabled>쿠폰종류</option>
              <option :value="{ value: p.value, type: p.type }" :key="i" v-for="(p, i) in this.sParam_array">{{ p.name }}</option>
            </select>
            <input type="text" v-model="this.keyWord_cp" style="font-size:0.9rem; background-color:lavender; width: 250px;" ref="memName" placeholder="쿠폰명">
            <button type="button" class="btn btn-outline-dark btn-sm" style="font-size: smaller; color:white; background-color: purple;" @click="searchCoupon(this.keyWord_cp)">검색</button>

            <span class="mx-1" style="color:lightgray;">|</span>

            <select class="form-select form-select-sm" v-model="this.selectedYear" style="width: 100px;">
              <option :value="y" :key="y" v-for="y in yearOptions">{{ y }}년</option>
            </select>
            <select class="form-select form-select-sm" v-model="this.dateBasis" style="width: 130px;">
              <option value="issue">발행일기준</option>
              <option value="exp">기한일기준</option>
            </select>
            <button type="button" class="btn btn-outline-primary btn-sm" style="font-size: smaller;" @click="filterAndSortCpList">연도별 정렬조회</button>
          </div>

          <div class="table-scroll">
            <table class="table table-bordered table-striped fs-6 align-item-center">
              <thead>
                <tr style="background-color: lightgray;">
                  <th style="font-size: 1rem; font-weight: 600; width:3%;">상태</th>
                  <th style="font-size: 1rem; font-weight: 600; width:12%;">쿠폰명</th>
                  <th style="font-size: 1rem; font-weight: 600; width:6%;">쿠폰코드</th>
                  <th style="font-size: 1rem; font-weight: 600; width:5%;">적용금액</th>
                  <th style="font-size: 1rem; font-weight: 600; width:5%;">적용대상</th>
                  <th style="font-size: 1rem; font-weight: 600; width:5%;">발행대상</th>
                  <th style="font-size: 1rem; font-weight: 600; width:6%;">발행일</th>
                  <th style="font-size: 1rem; font-weight: 600; width:6%;">기한일</th>
                  <th style="font-size: 1rem; font-weight: 600; width:3%;">발행</th>
                  <th style="font-size: 1rem; font-weight: 600; width:3%;">등록</th>
                  <th style="font-size: 1rem; font-weight: 600; width:3%;">사용</th>
                  <th style="font-size: 1rem; font-weight: 600; width:6%;">발행인</th>
                  <th style="font-size: 1rem; font-weight: 600; width:6%;">담당자</th>
                  <th style="font-size: 1rem; font-weight: 600; width:15%;">비고사항</th>
                  <th style="font-size: 1rem; font-weight: 600; width:5%;">기능</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr :key="i" v-for="(m, i) in this.issuedCpList" style="font-size:small;">
                  <td v-if="m.cpActive === 'Y'"><span class="badge-pill badge-mint">활성</span></td>
                  <td v-else-if="m.cpActive === 'N'"><span class="badge-pill badge-gray">비활성</span></td>
                  <td v-else><span class="badge-pill badge-info">??</span></td>

                  <td class="text-start">{{ m.cpName }}</td>
                  <td style="font-size: smaller">{{ m.cpCode }}</td>

                  <td v-if="m.cpPriceFlag == 'A'" style="color:red;">{{ this.getCurrencyFormat(m.cpPrice) }}원</td>
                  <td v-else-if="m.cpPriceFlag == 'R'" style="color:blue;">{{ this.getCurrencyFormat(m.cpPrice) }}%</td>
                  <td v-else><i class="bi bi-exclamation-triangle-fill text-danger fs-5"></i></td>

                  <td v-if="m.cpUseCode == 'AL'" class="tooltip">전체상품</td>
                  <td v-else-if="m.cpUseCode == 'AU'">전체유저</td>
                  <td v-else-if="m.cpUseCode == 'CA'" style="cursor: pointer;" @click="checkData('CA', m.cpCode, $event)"><i class="bi bi-search text-primary"></i>특정카테고리</td>
                  <td v-else-if="m.cpUseCode == 'PD'" style="cursor: pointer;" @click="checkData('PD', m.cpCode, $event)"><i class="bi bi-search text-primary"></i>특정상품</td>
                  <td v-else></td>

                  <td v-if="m.cpType == 'mAll'">전체회원</td>
                  <td v-else-if="m.cpType == 'pAll'">프리미엄</td>
                  <td v-else-if="m.cpType == 'sAll'">스탠다드</td>
                  <td v-else-if="m.cpType == 'sMem'" style="cursor: pointer;" @click="checkData('sMem', m.cpCode, $event)"><i class="bi bi-search text-success"></i>특정회원</td>
                  <td v-else-if="m.cpType == 'uAll'">전체(비회원포함)</td>
                  <td v-else-if="m.cpType == 'nMem'">회원가입조건</td>
                  <td v-else></td>

                  <td>{{ this.getDateFormat(m.cpIssueDate) }}</td>
                  <td>{{ this.getDateFormat(m.cpExpDate) }}</td>

                  <td v-if="m.cpIssueQtyIndef == 'N'">
                    <span>{{ this.getCurrencyFormat(m.firstQty) }}</span>
                  </td>
                  <td v-else-if="m.cpActive == 'N' && m.cpIssueQtyIndef == 'Y'">
                    <span><i class="bi bi-infinity fs-6"></i></span>
                  </td>
                  <td v-else-if="m.cpActive == 'Y' && m.cpIssueQtyIndef == 'Y'"></td>
                  <td v-else></td>

                  <td v-if="m.cpActive == 'N'">
                    <span class="text-success">{{ this.getCurrencyFormat(m.cpIssueQty) }}</span>
                  </td>
                  <td v-else></td>

                  <td>
                    <span class="text-danger">{{ this.getCurrencyFormat(m.usedQty) }}</span>
                  </td>

                  <td>{{ m.cpIssuer }}</td>
                  <td>{{ m.handlerNameKor }}</td>
                  <td>
                    <span style="text-align: left;">
                      <pre>{{ m.cpRemarks }}</pre>
                    </span>
                  </td>
                  <td>
                    <button class="btn btn-outline-danger btn-sm" v-if="m.cpValidFlag=='Y'" @click="changeCpStatus(m.cpCode, 'N')"><span>無效化</span></button>
                    <button class="btn btn-danger btn-sm" v-else @click="changeCpStatus(m.cpCode, 'Y')"><span>有效化</span></button>
                    <br>
                    <button class="btn btn-warning btn-sm" @click="parsingExcel(m.cpCode, m.cpName, m.cpPrice, m.cpPriceFlag, m.cpExpDate)">
                      <span style="color:black;">알림톡</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 레이어 팝업 -->
        <div v-if="showLayer" class="data-layer" :style="layerStyle">
          <div class="layer-content">
            <button @click="closeLayer" class="close-btn"><i class="bi bi-x-circle-fill"></i></button>
            <div class="layerData">
              {{ layerData && layerData.length ? layerData.join(', ') : '로딩 중...' }}
            </div>
          </div>
        </div>

        <!-- =============================================
          엑셀 업로드 팝업 (callNo 파싱 → 알림톡 발송)
        ============================================= -->
        <div v-if="excelUploadModal.show" class="modal-overlay" @click.self="closeExcelModal">
          <div class="modal-box">
            <div class="modal-header">
              <h3><i class="bi bi-cloud-arrow-up-fill text-info"></i>&nbsp;알림톡 발송번호 업로드</h3>
              <button class="btn-close" @click="closeExcelModal">✕</button>
            </div>
            <div class="modal-body">
              <p class="modal-info">
                <strong>{{ excelUploadModal.cpName }}</strong>&nbsp;
                <span style="font-size:smaller; color:gray;">({{ excelUploadModal.cpCode }})</span>
              </p>

              <!-- 드래그앤드롭 + 클릭 업로드 영역 -->
              <div
                class="upload-area" :class="{ 'drag-over': isDragOver }"
                @dragover.prevent="isDragOver = true"
                @dragleave.prevent="isDragOver = false"
                @drop.prevent="onFileDrop"
                @click="$refs.excelFileInput.click()">
                <input type="file" ref="excelFileInput" accept=".xlsx,.xls,.csv" style="display:none" @change="onFileChange"/>

                <!-- 파일 미선택 상태 -->
                <div v-if="!excelUploadModal.file" class="upload-placeholder">
                  <span class="upload-icon">📂</span>
                  <span>파일을 드래그하거나 클릭하여 선택</span>
                  <small>.xlsx / .xls / .csv &nbsp;|&nbsp; <b>callNo</b> 컬럼 필수</small>
                </div>

                <!-- 파일 선택됨 -->
                <div v-else class="file-selected">
                  <span>✅ {{ excelUploadModal.file.name }}</span>
                  <button class="btn-file-clear" @click.stop="clearFile">✕</button>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn-cancel" @click="closeExcelModal">취소</button>
              <button class="btn-upload" :disabled="!excelUploadModal.file" @click="submitExcelUpload">발송대상저장</button>
            </div>
          </div>
        </div>
        <!-- // 엑셀 업로드 팝업 -->

      </div>
    </main>
  </div>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions'
import LoadingSpinner from '../components/LoadingSpinner.vue'
import { generateCouponCode } from '../assets/js/genCode'
import dayjs from "dayjs"
import * as XLSX from 'xlsx'

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      isLoading: false,

      show_cpUseCode: "N",
      cpUseCodeList: [],
      cpUseCodeList_org: [],

      keyWord: "",
      pdtCategoryList: [],
      catCode: "",

      show_cpType: "N",
      memberInfo: [],
      memberInfo_org: [],

      allSelected: "N",
      allSelected_ct: "N",

      cpActive: "",
      cpUseCode: "",
      cpType: "",
      cpName: "",
      cpPrice: 0,
      cpPriceFlag: "",
      firstQty: 0,
      cpIssueQty: 0,
      cpIssueDate: dayjs().format('YYYY-MM-DD'),
      cpExpIndef: "",
      cpExpDate: "",
      cpIssuer: "엔타비글로벌",
      cpRemarks: "",

      selectedCpUse: "",
      selectedCpUseArray: [],

      selectedcpType: "",
      selectedcpTypeArray: [],

      selectedMemId_array: [],

      issuedCpList: [],
      issueCpList_org: [],

      sParam: "",
      sParam_array: [
        { value:"All" , type:"aL" , name: "전체보기" },
        { value:"Y"   , type:"cA" , name: "활성쿠폰" },
        { value:"N"   , type:"cA" , name: "비활성쿠폰" },
        { value:"mAll", type:"cT" , name: "전체회원용" },
        { value:"pAll", type:"cT" , name: "프리미엄회원용" },
        { value:"sAll", type:"cT" , name: "스탠다드회원용" },
        { value:"sMem", type:"cT" , name: "특정회원한정" },
        { value:"CA"  , type:"cA" , name: "특정카테고리한정" },
        { value:"PD"  , type:"cA" , name: "특정상품한정" }
      ],

      catLimitedCoupon: [],
      pdtLimitedCoupon: [],

      showLayer: false,
      layerPosition: { x: 0, y: 0 },
      layerData: null,
      cpIssueQtyIndef: "",

      // ── 연도/기준일 필터 상태 ──
      selectedYear: dayjs().format('YYYY'),
      dateBasis: 'issue', // 'issue': 발행일기준 / 'exp': 기한일기준

      // ── 엑셀 업로드 팝업 상태 ──
      excelUploadModal: {
        show: false,
        cpCode: '',
        cpName: '',
        cpPrice: '',
        cpPriceFlag: '',
        cpExpDate: '',
        file: null,
      },
      isDragOver: false,
    };
  },

  created() {
    this.user = this.$store.state.user;
    this.filterAndSortCpList();
    this.getHandlerInfo();
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    layerStyle() {
      return {
        left: `${this.layerPosition.x}px`,
        top: `${this.layerPosition.y}px`,
        minWidth: '300px',
        maxWidth: '600px',
        position: 'absolute',
      }
    },
    yearOptions() {
      const years = new Set()
      years.add(dayjs().format('YYYY')) // 데이터가 없어도 당해년도는 항상 노출
      this.issueCpList_org.forEach(item => {
        if(item.cpIssueDate) years.add(dayjs(item.cpIssueDate).format('YYYY'))
        if(item.cpExpDate)   years.add(dayjs(item.cpExpDate).format('YYYY'))
      })
      return Array.from(years).sort((a, b) => b - a)
    }
  },

  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({ title: '로그인 필요', text: '접근권한 확인불가.', icon: 'error' });
      this.$router.push({ path: '/' });
    }
    document.getElementById("user").style.display = "none";
  },

  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    pageReload() {
      this.$swal.fire({
        html: '화면을 초기화하시겠습니까?',
        showCancelButton: true,
        confirmButtonText: "YES",
        cancelButtonText: "NO"
      }).then((result) => {
        if(result.isConfirmed) location.reload()
      })
    },

    // ================================================
    //  엑셀 업로드 팝업 관련 메소드
    // ================================================

    /** 알림톡 버튼 클릭 → 팝업 오픈 */
    parsingExcel(cpCode, cpName, cpPrice, cpPriceFlag, cpExpDate) {
      console.log("parsingExcel params:", cpCode, cpName, cpPrice, cpPriceFlag, cpExpDate)
      this.excelUploadModal = {
        show: true,
        cpCode,
        cpName,
        cpPrice,
        cpPriceFlag,
        cpExpDate,
        file: null,
      }
      this.isDragOver = false
    },

    /** 팝업 닫기 */
    closeExcelModal() {
      this.excelUploadModal.show = false
      this.excelUploadModal.file = null
      this.isDragOver = false
      if (this.$refs.excelFileInput) {
        this.$refs.excelFileInput.value = ''
      }
    },

    /** input[file] 변경 */
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) this.validateAndSetFile(file)
    },

    /** 드래그앤드롭 */
    onFileDrop(e) {
      this.isDragOver = false
      const file = e.dataTransfer.files[0]
      if (file) this.validateAndSetFile(file)
    },

    /** 확장자 검증 후 파일 세팅 */
    validateAndSetFile(file) {
      const extAllowed = /\.(xlsx|xls|csv)$/i.test(file.name)
      if (!extAllowed) {
        this.$swal.fire('', '.xlsx / .xls / .csv 파일만 가능합니다.', 'warning')
        return
      }
      this.excelUploadModal.file = file
    },

    /** 파일 선택 초기화 */
    clearFile() {
      this.excelUploadModal.file = null
      if (this.$refs.excelFileInput) {
        this.$refs.excelFileInput.value = ''
      }
    },

    /**
     * 모바일번호 정규화
     * +82 10-1234-5678 → 01012345678
     * 010-1234-5678    → 01012345678
     * 010 1234 5678    → 01012345678
     */
    normalizeCallNo(raw) {
      let num = String(raw ?? '').trim()

      // 1. 국제번호 +82 → 0 으로 변환
      if (num.startsWith('+82')) {
        num = '0' + num.replace('+82', '').trim()
      }

      // 2. 하이픈, 공백, 괄호 등 특수문자 제거
      num = num.replace(/[-\s()+]/g, '')

      return num
    },

    /**
     * 파일 파싱 → callNo/callName 추출 → 번호 정규화/검증
     * → 벌크 INSERT → (TODO) 카카오 알림톡 발송
     */
    async submitExcelUpload() {
      const { cpCode, file } = this.excelUploadModal
      if (!file) return

      try {
        // 1. 브라우저에서 직접 파싱
        const buffer   = await file.arrayBuffer()
        const workbook = XLSX.read(buffer, { type: 'array' })
        const sheet    = workbook.Sheets[workbook.SheetNames[0]]
        const rows     = XLSX.utils.sheet_to_json(sheet)

        // 2. callNo가 있는 전체 row 수 (제외 건수 계산용)
        const totalRows = rows.filter(r =>
          r['callNo'] !== undefined && r['callNo'] !== null && r['callNo'] !== ''
        ).length

        // 3. callNo/callName 추출 + 번호 정규화 + 유효성 검증
        //    01로 시작하는 10~11자리 숫자만 통과
        const callNoList = rows
          .map(row => {
            const callNo = this.normalizeCallNo(row['callNo'])
            return {
              callName: row['callName'] ?? '',
              callNo
            }
          })
          .filter(v => /^01[0-9]{8,9}$/.test(v.callNo))

        // 4. 유효한 번호가 없는 경우
        if (callNoList.length === 0) 
        {
          this.$swal.fire(
            '',
            'callNo 컬럼 데이터가 없거나\n유효한 모바일 번호가 없습니다.\n(01로 시작하는 10~11자리 숫자)',
            'warning'
          )
          return
        }

        // 5. 제외된 번호가 있으면 안내 후 계속 진행
        const skipped = totalRows - callNoList.length
        if (skipped > 0) 
        {
          await this.$swal.fire(
            '',
            `총 ${totalRows}건 중 <b>${skipped}건</b>은 유효하지 않은 번호로 제외되었습니다.<br>${callNoList.length}건만 저장합니다.<br>엑셀파일을 체크하세요`,
            'info'
          )
        }

        console.log('정규화된 callNoList:', callNoList)
        this.isLoading = true

        // 6. 벌크 INSERT용 2차원 배열 생성
        const insId      = this.user.handlerId
        const now        = dayjs().format('YYYY-MM-DD HH:mm:ss')
        const bulkValues = callNoList.map(item => [cpCode, item.callName, item.callNo, now, insId])

        // 7. API 호출하여 DB 저장 후, 발송처리 확인 -> 발송완료 후 팝업 닫기
        const res = await this.$api('/api/insCouponAlim', { param: [bulkValues] })

        if (res?.affectedRows > 0) 
        {
          this.isLoading = false

          // DB 저장 완료 후 카카오 발송 여부 확인
          const { isConfirmed } = await this.$swal.fire({
            title: `${callNoList.length}건 저장 완료!`,
            text: '알림톡을 발송하시겠습니까?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: '알림톡발송',
            cancelButtonText: '발송취소',
          })

          if(isConfirmed) 
          {
            this.sendKakao("CP", callNoList, this.excelUploadModal)
          }
          else 
          {
            let callNoArray = callNoList.map(item => item.callNo)
            //취소: cxlFlag Y로 업데이트 (발송 제외 처리)
            let cxlRes = await this.$api('/api/cxlCouponAlim', { param: [ cpCode, callNoArray] })
            if(cxlRes?.affectedRows > 0) 
            {
              this.closeExcelModal()
            }
            else 
            {
              this.$swal.fire('', '취소처리 중 오류가 발생했습니다.', 'error')
              return false
            }
          }
        } 
        else 
        {
          this.$swal.fire('', '저장 중 오류가 발생했습니다.', 'error')
        }
      } 
      catch (err) 
      {
        console.error('처리 실패:', err)
        this.$swal.fire('', '파일 처리 중 오류가 발생했습니다.', 'error')
      } 
      finally 
      {
        this.isLoading = false
      }
    },

    async getHandlerInfo() {
      let handTel = await handlerInfo(this.$api)
      if(handTel.length > 0) this.handTel = handTel
    },

    //쿠폰발행 알림톡
    async sendKakao(param, callNoList, cpInfo)
    {
      console.log("sendKakao param:", param, "callNoList:", callNoList, "cpInfo:", cpInfo)

      try 
      {
        this.isLoading = true

        let cpPrice = ""
        if(cpInfo.cpPriceFlag === "A")
        {
          cpPrice = this.getCurrencyFormat(cpInfo.cpPrice) + "원"
        }
        else if(cpInfo.cpPriceFlag === "R")
        {
          cpPrice = this.getCurrencyFormat(cpInfo.cpPrice) + "%"
        }
        else
        {
          cpPrice = "표시없음"
        }

        //1. 발송대상 확정
        //내부직원(handTel) + 고객 callNoList 합산
        const sendTargets = []

        // 내부직원 연락처 추가 (handlerInfo에서 가져온 this.handTel)
        this.handTel.forEach(h => {
          sendTargets.push({
            callNo  : h.aimCall,
            callName: h.handlerName ?? '직원확인용'   // handlerInfo에 이름 필드가 있으면 사용
          })
        })

        // 고객 callNoList 추가
        callNoList.forEach(item => {
          sendTargets.push({
            callNo  : item.callNo,
            callName: item.callName
          })
        })

        console.log('최종 발송 대상:>>>>', sendTargets)

        // ✅ 2. 병렬 발송
        const promises = sendTargets.map(target => {
          const kakaoAlimData = {
            alimFlag  : param,              // 알림유형 'CP'
            clientCall: target.callNo,      // 발송 대상 번호
            clientName: target.callName,    // 수신자명
            cpCode    : cpInfo.cpCode,
            cpName    : cpInfo.cpName,
            cpPrice   : cpPrice,
            cpExpDate : cpInfo.cpExpDate,
            resCode   : cpInfo.cpCode,
          }
          return this.$api("api/kakaoAlimSend9", { param: [{ kakaoAlimData }] })
            .then(r  => ({ callNo: target.callNo, success: true,  result: r }))
            .catch(() => ({ callNo: target.callNo, success: false }))
        })

        // ✅ 3. 결과 처리
        const results    = await Promise.all(promises)
        const failedList = results.filter(r => !r.success).map(r => r.callNo)
        const successList = results.filter(r => r.success).map(r => r.callNo)

        //성공한 번호들은 DB업데이트
        const customerCallNos = callNoList.map(item => item.callNo)
        //성공한 번호들 중 엑셀에 있는 것만 업데이트 (직원확인용 번호는 제외) <- DB업데이트 목적
        const successCustomerNos = successList.filter(no => customerCallNos.includes(no))

        // 발송성공 DB업데이트
        if (successCustomerNos.length > 0) 
        {
          //const sendDate = dayjs().format('YYYY-MM-DD HH:mm:ss')
          const updRes   = await this.$api('/api/updCouponAlimSend', {param: [
            cpInfo.cpCode, successCustomerNos
          ]})
          console.log(`DB 업데이트 완료: ${updRes?.affectedRows}건`)
        }


        if (failedList.length > 0) 
        {
          this.$swal.fire('', `발송 실패 번호 ${failedList.length}건:\n${failedList.join(', ')}`, 'warning')
        } 
        else 
        {
          this.$swal.fire('', `총 ${sendTargets.length}건 알림톡 발송 완료!\n(직원확인용 ${this.handTel.length}건 + 고객 ${callNoList.length}건)`, 'success')
        }
      }
      catch (err) 
      {
        console.error('카카오 발송 실패:', err)
        this.$swal.fire('', '알림톡 발송 중 오류가 발생했습니다.', 'error')
      } 
      finally 
      {
        this.isLoading = false
        this.closeExcelModal()
      }
    },

    async changeSearchCode(sp){
      await this.getIssuedCpList()
      this.issuedCpList = this.issueCpList_org
      if(sp.value === "All" && sp.type === "aL") {
        this.issuedCpList
      } else if(sp.type === "cA") {
        if(sp.value === "Y")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpActive === "Y")
        else if(sp.value === "N")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpActive === "N")
        else if(sp.value === "CA")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpUseCode === "CA")
        else if(sp.value === "PD")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpUseCode === "PD")
      } else if(sp.type === "cT") {
        if(sp.value === "mAll")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpType === "mAll")
        else if(sp.value === "pAll")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpType === "pAll")
        else if(sp.value === "sAll")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpType === "pAll")
        else if(sp.value === "sMem")
          this.issuedCpList = this.issueCpList_org.filter(item => item.cpType === "sMem")
      }
    },

    async searchCoupon(kw) {
      await this.getIssuedCpList()
      this.issuedCpList = this.issueCpList_org.filter(item =>
        item.cpName.toLowerCase().includes(kw.toLowerCase())
      )
    },

    async checkData(type, code, event) {
      const rect = event.target.closest('td').getBoundingClientRect()
      this.layerPosition = {
        x: rect.left + window.scrollX,
        y: rect.top + rect.height + window.scrollY
      }
      try {
        if(type === "CA") {
          let catLimitedCoupon = await this.$api("/api/catLimitedCoupon", {param: [ code ]})
          this.catLimitedCoupon = catLimitedCoupon
          this.layerData = catLimitedCoupon?.map(item => item.codeNameKor) || []
        } else if(type === "PD") {
          let pdtLimitedCoupon = await this.$api("/api/pdtLimitedCoupon", {param: [ code ]})
          this.pdtLimitedCoupon = pdtLimitedCoupon
          this.layerData = pdtLimitedCoupon?.map(item => item.pdtNameKor) || []
        } else if(type === "sMem") {
          let pdtMemberCoupon = await this.$api("/api/pdtMemberCoupon", {param: [ code ]})
          this.pdtMemberCoupon = pdtMemberCoupon
          this.layerData = pdtMemberCoupon?.map(item => `${item.uNickName} (${item.cpMemId}, ${item.mLevel})`) || []
        }
        this.showLayer = true
      } catch (err) {
        console.error(err)
      }
    },

    closeLayer() {
      this.showLayer = false
      this.layerData = null
    },

    async changeCpStatus(cc, stat) {
      this.$swal.fire({
        html: '쿠폰의 효력을 변경하시겠습니까?(유효<->무효)',
        showCancelButton: true,
        confirmButtonText: "YES",
        cancelButtonText: "NO"
      }).then(async (result) => {
        if(result.isConfirmed) {
          let res_changeCpStat = await this.$api("/api/changeCpStat", {param: [ stat, cc ]})
          if(res_changeCpStat.affectedRows > 0) {
            this.$swal.fire("", "쿠폰상태가 변경되었습니다", "info").then(() => {
              this.getIssuedCpList()
            })
          } else {
            this.$swal.fire("", "쿠폰상태가 변경에 오류가 발생했습니댜.", "warning")
            return false
          }
        }
      })
    },

    async getIssuedCpList() {
      let issuedCpList = await this.$api("/api/issuedCouponList", {});
      if(issuedCpList.length > 0) {
        let issueCpList_desc = issuedCpList.sort((a, b) => b.cpSeq - a.cpSeq)
        this.issueCpList_org = issueCpList_desc
        this.issuedCpList   = issueCpList_desc
      }
    },

    async filterAndSortCpList() {
      this.isLoading = true
      try {
        await this.getIssuedCpList() // 최신 데이터로 갱신 후 필터

        const dateField = this.dateBasis === 'issue' ? 'cpIssueDate' : 'cpExpDate'

        let filtered = this.issueCpList_org.filter(item => {
          if(!item[dateField]) return false
          return dayjs(item[dateField]).format('YYYY') === String(this.selectedYear)
        })

        filtered.sort((a, b) => dayjs(b[dateField]).valueOf() - dayjs(a[dateField]).valueOf())

        this.issuedCpList = filtered
      } finally {
        this.isLoading = false
      }
    },

    async getPdtCategoryList() {
      let pdtCategoryList = await this.$api("/api/pdt_categoryList", {});
      if(pdtCategoryList.length > 0) this.pdtCategoryList = pdtCategoryList
    },

    changeCatCode(catCode) {
      if(catCode === "A")
        this.cpUseCodeList = this.cpUseCodeList_org
      else
        this.cpUseCodeList = this.cpUseCodeList_org.filter(item => item.salesRoute === catCode)
    },

    allChoice(param) {
      if(param === "CU") {
        this.cpUseCodeList.forEach(cu => { cu.checkFlag = !!this.allSelected })
      } else if(param === "CT") {
        this.memberInfo.forEach(m => { m.checkFlag = !!this.allSelected_ct })
      }
    },

    removeCpUse(idx) {
      this.selectedCpUseArray.splice(idx, 1)
    },

    removeCpType(idx) {
      const removed = this.selectedcpTypeArray.splice(idx, 1)[0]
      this.selectedMemId_array = this.selectedMemId_array.filter(mem => mem.memId !== removed)
    },

    async saveTemp_selItems(flag, param) {
      if(param === "CU") {
        let selectedCpUse = []
        if(flag === 'CA') {
          this.cpUseCodeList.forEach(cu => {
            if(cu.checkFlag) selectedCpUse.push({ code: cu.baseCode, name: cu.codeNameKor })
            cu.checkFlag = null
          })
        } else if(flag === 'PD') {
          this.cpUseCodeList.forEach(cu => {
            if(cu.checkFlag) selectedCpUse.push({ code: cu.pdtCode, name: cu.pdtNameKor })
            cu.checkFlag = null
          })
        }
        if(selectedCpUse.length < 1) {
          this.$swal.fire("","선택된 적용대상이 없습니다.","warning")
          return false
        }
        selectedCpUse.forEach(item => {
          if(!this.selectedCpUseArray.some(x => x.code === item.code))
            this.selectedCpUseArray.push(item)
        })
        this.$swal.fire("","적용대상이 선택되었습니다","success")
      }
      if(param === 'CT') {
        let selectedcpType_array = []
        if(flag === 'sMem') {
          this.memberInfo.forEach(m => {
            if(m.checkFlag) selectedcpType_array.push({ memId: m.uEmail, memCall: m.alimCallC, memName: m.uNickName })
            m.checkFlag = null
          })
        }
        if(selectedcpType_array.length < 1) {
          this.$swal.fire("","선택된 발행대상이 없습니다.","warning")
          return false
        }
        selectedcpType_array.forEach(newMem => {
          if(!this.selectedcpTypeArray.some(x => x.memId === newMem.memId))
            this.selectedcpTypeArray.push({ memId: newMem.memId, memName: newMem.memName, memCall: newMem.memCall })
        })
        selectedcpType_array.forEach(newMem => {
          if(!this.selectedMemId_array.some(mem => mem.memId === newMem.memId))
            this.selectedMemId_array.push(newMem)
        })
        this.$swal.fire("","발행대상이 선택되었습니다.","success")
      }
    },

    async show_cpUseCodeList(cu, param, prop) {
      this.selectedCpUse = []
      if(prop != 'search') this.selectedCpUseArray = []

      if(param == "") {
        if(this.cpActive == "") {
          this.$swal.fire("","쿠폰상태를 선택하세요.","warning")
          this.cpUseCode = ""
          return false
        }
      }
      this.getPdtCategoryList()
      this.keyWord = ""
      this.show_cpUseCode = "N"
      this.allSelected = "N"
      this.isLoading = true

      try {
        let cpUseCodeList_tmp    = []
        let cpUseCodeList_search = []

        if(param == "") {
          if(cu === "CA" || cu === "PD") {
            this.show_cpUseCode = "Y"
            if(cu === "CA")
              cpUseCodeList_tmp = await this.$api("/api/pdtCatInfoList", {param: []})
            else if(cu === "PD")
              cpUseCodeList_tmp = await this.$api("/api/pdtInfoList_new", { param: [] })
          } else {
            this.show_cpUseCode = "N"
          }
        } else if(param === "Y") {
          this.show_cpUseCode = "Y"
          cpUseCodeList_search = await this.$api("/api/pdtInfoListBykeyword_new", {param: [ cu ]})
        }

        if(cpUseCodeList_tmp.length > 0) {
          this.cpUseCodeList_org = cpUseCodeList_tmp
          this.cpUseCodeList     = cpUseCodeList_tmp
        }
        if(cpUseCodeList_search.length > 0) {
          this.cpUseCodeList = cpUseCodeList_search
        }
      } finally {
        this.isLoading = false
      }
    },

    searchProduct(kw, sType, prop) {
      if(!kw) {
        this.$swal.fire("","검색어를 입력하세요.","warning")
        return false
      }
      if(sType === "CU") this.show_cpUseCodeList(kw, "Y", prop)
      else if(sType === "CT") this.getMemberList(kw)
    },

    async show_cpTypeList(ct, param) {
      this.selectedcpType      = []
      this.selectedcpTypeArray = []
      if(param == "") {
        if(this.cpUseCode == "") {
          this.$swal.fire("","쿠폰적용대상을 선택하세요.","warning")
          this.cpType = ""
          return false
        }
      }
      this.show_cpType = "Y"
      this.getMemberList()
      this.keyWord     = ""
      this.allSelected = "N"
    },

    async getMemberList(kw) {
      this.isLoading = true
      try {
        let memberInfo = await this.$api("/api/memberInfoList", {})
        if(memberInfo.length > 0) {
          this.memberInfo_org = memberInfo
          this.memberInfo     = memberInfo
        }
        if(kw != "" && kw != undefined) {
          this.memberInfo = this.memberInfo_org.filter(item =>
            item.uNickName.toLowerCase().includes(kw.toLowerCase())
          )
        }
      } finally {
        this.isLoading = false
      }
    },

    async changeProcCode(param) {
      if(param === 'A') this.getMemberList()
      else if(param === "Pre")
        this.memberInfo = this.memberInfo_org.filter(item => item.memLevel === 'P' && item.testFlag != 'Y')
      else if(param === "Std")
        this.memberInfo = this.memberInfo_org.filter(item => item.memLevel === 'S' && item.testFlag != 'Y')
    },

    async genCpCode(cpQty) {
      let today = new Date()
      let yy  = today.getFullYear().toString().slice(-2)
      let mm  = today.getMonth() + 1
      let dd  = today.getDate()
      let ymd = `${yy}${mm}${dd}`
      return await generateCouponCode(this.$api, ymd, cpQty)
    },

    async makeCoupon() {
      if(!this.cpActive)                              { this.$swal.fire("","쿠폰상태를 선택하세요.","warning"); return false }
      if(!this.cpUseCode)                             { this.$swal.fire("","쿠폰적용대상을 선택하세요.","warning"); return false }
      if(!this.cpType && this.cpActive === 'active')  { this.$swal.fire("","쿠폰발행대상을 선택하세요.","warning"); return false }
      if(!this.cpName)                                { this.$swal.fire("","쿠폰명을 입력하세요.","warning"); return false }
      if(!this.cpPrice)                               { this.$swal.fire("","쿠폰적용금액을 입력하세요.","warning"); return false }
      if(!this.cpPriceFlag)                           { this.$swal.fire("","쿠폰적용금액 단위를 선택하세요.","warning"); return false }
      if(this.firstQty < 0)                           { this.$swal.fire("","쿠폰발행수량을 확인하세요.","warning"); return false }
      if(!this.cpIssueDate)                           { this.$swal.fire("","쿠폰발행일자를 입력하세요.","warning"); return false }
      if(!this.cpExpDate) {
        this.cpExpIndef = "Y"
        this.cpExpDate  = "2999-12-31"
      } else {
        this.cpExpIndef = "N"
      }
      if(!this.cpIssuer) { this.$swal.fire("","쿠폰발행자를 입력하세요.","warning"); return false }
      if(this.firstQty == 0)      this.cpIssueQtyIndef = "Y"
      else if(this.firstQty > 0)  this.cpIssueQtyIndef = "N"
      else { this.$swal.fire("","발행수량에 오류가 있습니다.","warning"); return false }

      let cpCode_rtn = await this.genCpCode(this.firstQty)
      let cpCode = ""
      if(cpCode_rtn == "noCpCode") {
        this.$swal.fire("", "쿠폰코드가 계속 중복되어 발생하고 있습니다. 개발자에게 연락해주세요!")
        return false
      } else {
        cpCode = cpCode_rtn
        this.cpCode = cpCode
      }

      let cpActive         = this.cpActive == 'active' ? 'Y' : 'N'
      let cpUseCode        = this.cpUseCode
      let cpType           = this.cpType
      let cpName           = this.cpName
      let cpPrice          = this.cpPrice
      let cpPriceFlag      = this.cpPriceFlag
      let cpIssueQty       = 0
      let cpIssueDate      = this.cpIssueDate
      let cpExpDate        = this.cpExpDate
      let cpIssuer         = this.cpIssuer
      let cpRemarks        = this.cpRemarks
      let cpInsId          = this.user.handlerId
      let cpValidFlag      = "Y"
      let cpWithPoint      = "N"
      let cpExpIndef       = this.cpExpIndef
      let cpIssueQtyIndef  = this.cpIssueQtyIndef
      let firstQty         = this.firstQty

      let makeCoupon = await this.$api("/api/proc_makeUserCoupon", {param: [
        cpActive, cpCode, cpUseCode, cpType, cpName, cpPrice, cpPriceFlag, cpIssueQty, cpIssueDate, cpIssuer, cpExpDate, cpRemarks, cpInsId, cpValidFlag, cpWithPoint, cpExpIndef, cpIssueQtyIndef, firstQty
      ]})

      const affectedRows = makeCoupon[0][0]?.affectedRows || 0

      if(affectedRows > 0) {
        if(this.cpUseCode === "CA" || this.cpUseCode === "PD") {
          if(this.cpUseCode === "CA") {
            const promises = this.selectedCpUseArray.map(cu =>
              this.$api("/api/insCuponDetail_cu", {param: [ this.cpCode, cu.code, "" ]})
                .then(r => ({ success: r?.affectedRows > 0 }))
                .catch(() => ({ success: false }))
            )
            const results = await Promise.all(promises)
            if(results.filter(r => !r.success).length > 0)
              this.$swal.fire("", "적용대상(카테고리) 저장 중 오류발생!", "error")
          } else if(this.cpUseCode === "PD") {
            const promises = this.selectedCpUseArray.map(cu =>
              this.$api("/api/insCuponDetail_cu", {param: [ this.cpCode, "", cu.code ]})
                .then(r => ({ success: r?.affectedRows > 0 }))
                .catch(() => ({ success: false }))
            )
            const results = await Promise.all(promises)
            if(results.filter(r => !r.success).length > 0)
              this.$swal.fire("", "적용대상(상품정보) 저장 중 오류발생!", "error")
          }
        }

        if(this.cpType === 'sMem') {
          const promises = this.selectedcpTypeArray.map(ct =>
            this.$api("/api/insCuponDetail_ct", {param: [ this.cpCode, ct.memId ]})
              .then(r => ({ success: r?.affectedRows > 0 }))
              .catch(() => ({ success: false }))
          )
          const results = await Promise.all(promises)
          const fails   = results.filter(r => !r.success)
          if(results.length > 0)
            await this.sendCpToMember(this.selectedMemId_array, cpCode)
          else if(fails.length > 0) {
            this.$swal.fire("", "쿠폰발행대상 저장처리 중 오류가 발생했습니다.", "error")
            return false
          }
        } else {
          this.$swal.fire('', '쿠폰이 생성되었습니다', 'success').then(() => {
            this.getIssuedCpList()
            this.cpActive = ""
          })
        }
      } else {
        this.$swal.fire('', '쿠폰생성에 실패했습니다', 'error')
        return false
      }
    },

    async sendCpToMember(mList, cpCode) {
      const promises = mList.map(user =>
        this.$api("/api/proc_sendUserCoupon", {param: [user.memId, cpCode, "N", user.memCall]})
          .then(r => ({ userId: user.memId, success: r[0][0]?.affectedRows > 0 }))
          .catch(() => ({ userId: user.memId, success: false }))
      )
      const results     = await Promise.all(promises)
      const failedUsers = results.filter(r => !r.success).map(r => r.userId)

      if(failedUsers.length > 0) {
        this.$swal.fire('', `쿠폰등록에 실패한 사용자 ID: ${failedUsers.join(", ")}=>쿠폰을 생성해주세요`, 'error')
      } else {
        this.$swal.fire('', '쿠폰이 생성되었습니다', 'success').then(() => {
          this.getIssuedCpList()
          this.cpActive = ""
        })
      }
    },
  }
}
</script>

<style scoped>
/* ============ Design Tokens ============ */
.coupon-page {
  --bg: #F5FAF7;
  --card: #FFFFFF;
  --card-border: #E4EEE8;
  --ink: #1E2B24;
  --ink-soft: #4E5F57;
  --mint: #2FAE72;
  --mint-deep: #1F8659;
  --mint-soft: #E3F7EC;
  --coral: #FF7A59;
  --coral-soft: #FFE9E2;
  --sun: #FFB020;
  --danger: #E5484D;
  --danger-soft: #FDE7E8;
  --radius-lg: 18px;
  --radius-md: 12px;
  --radius-sm: 8px;
  --shadow-sm: 0 1px 3px rgba(30,43,36,0.06);
  --shadow-md: 0 4px 16px rgba(30,43,36,0.08);

  background: var(--bg);
  color: var(--ink);
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 8px 12px 32px;
}

.coupon-page input,
.coupon-page textarea,
.coupon-page select { width: 100%; box-sizing: border-box; }

/* ============ 티켓 헤더 배너 ============ */
.coupon-page .alert-info {
  background: linear-gradient(135deg, var(--mint) 0%, var(--mint-deep) 100%);
  border: none;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  color: #fff;
  padding: 18px 20px 20px;
  box-shadow: var(--shadow-md);
  position: relative;
  margin-bottom: 24px;
}
.coupon-page .alert-info b { color: #fff; letter-spacing: 4px; }
.coupon-page .alert-info::after {
  content: '';
  position: absolute; left: 0; right: 0; bottom: -10px;
  height: 20px;
  background-image: repeating-linear-gradient(to right, rgba(255,255,255,0.7) 0 8px, transparent 8px 16px);
  background-position: center; background-size: 16px 2px; background-repeat: repeat-x;
}

/* ============ 섹션 카드 & 절취선 시그니처 ============ */
.section-card {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 18px 20px;
  text-align: left;
}
.section-label {
  font-size: 0.95rem; font-weight: 700; color: var(--mint-deep);
  display: inline-flex; align-items: center; gap: 6px; margin-bottom: 12px;
}
.section-label::before {
  content: ''; width: 6px; height: 6px; border-radius: 50%; background: var(--coral);
}
.section-card--compact {
  padding: 10px 16px;
}
.section-card--compact .section-label {
  margin-bottom: 6px;
  font-size: 0.85rem;
}
.section-divider {
  position: relative;
  height: 20px;
  margin: 4px 0 14px;
  background-image: repeating-linear-gradient(to right, var(--card-border) 0 8px, transparent 8px 16px);
  background-position: center; background-size: 16px 2px; background-repeat: repeat-x;
}
.section-divider::before, .section-divider::after {
  content: ''; position: absolute; top: 50%; transform: translateY(-50%);
  width: 20px; height: 20px; background: var(--bg); border-radius: 50%;
}
.section-divider::before { left: -10px; }
.section-divider::after { right: -10px; }

/* ============ 버튼 ============ */
.coupon-page .btn { border-radius: var(--radius-sm); font-weight: 600; transition: transform .15s ease, box-shadow .15s ease, background .15s ease; }
.coupon-page .btn-primary { background: var(--mint); border-color: var(--mint); box-shadow: var(--shadow-sm); }
.coupon-page .btn-primary:hover { background: var(--mint-deep); border-color: var(--mint-deep); transform: translateY(-1px); box-shadow: var(--shadow-md); }
.coupon-page .btn-success { background: var(--coral); border-color: var(--coral); color: #fff; }
.coupon-page .btn-success:hover { background: #E85F3E; border-color: #E85F3E; transform: translateY(-1px); }
.coupon-page .btn-outline-primary { color: var(--mint-deep); border-color: var(--mint); }
.coupon-page .btn-outline-primary:hover { background: var(--mint-soft); color: var(--mint-deep); }
.coupon-page .btn-outline-danger:hover { background: var(--danger-soft); }
.coupon-page .btn-warning { background: var(--sun); border-color: var(--sun); }
.coupon-page .btn-outline-dark { border-radius: var(--radius-sm); }

/* ============ 폼 컨트롤 ============ */
.coupon-page .form-select,
.coupon-page input[type=text],
.coupon-page input[type=number],
.coupon-page input[type=date],
.coupon-page textarea {
  border: 1px solid var(--card-border);
  border-radius: var(--radius-sm);
  transition: border-color .15s ease, box-shadow .15s ease;
}
.coupon-page .form-select:focus,
.coupon-page input:focus,
.coupon-page textarea:focus {
  border-color: var(--mint);
  box-shadow: 0 0 0 3px var(--mint-soft);
  outline: none;
}

/* ============ 테이블 공통 ============ */
.coupon-page .table { border-collapse: separate; border-spacing: 0; }
.coupon-page .table-bordered { border: 1px solid var(--card-border); border-radius: var(--radius-md); overflow: hidden; }
.coupon-page .table thead tr { background: var(--mint-soft) !important; }
.coupon-page .table thead th { color: var(--mint-deep); border-color: var(--card-border); font-weight: 700; font-size: 0.85rem; letter-spacing: .2px; }
.coupon-page .table td, .coupon-page .table th { border-color: var(--card-border); vertical-align: middle; }
.coupon-page .table-striped > tbody > tr:nth-of-type(odd) { background-color: #FAFDFB; }
.coupon-page .table tbody tr:hover { background-color: var(--mint-soft); transition: background-color .15s ease; }
.coupon-page .text-primary { color: var(--mint-deep) !important; }
.coupon-page .text-success { color: var(--coral) !important; }
.coupon-page td pre {
  max-width: 220px; white-space: pre-wrap; word-break: break-word;
  font-family: inherit; font-size: 0.85rem; line-height: 1.5; color: var(--ink-soft); margin: 0;
}

/* ============ 리스트 스크롤 + 헤더 고정 ============ */
.table-scroll {
  max-height: min(78vh, 1400px); /* 발행쿠폰리스트: 화면을 최대한 활용해 많은 라인을 노출 */
  overflow-y: auto;
  border-radius: var(--radius-md);
  border: 1px solid var(--card-border);
}
.table-scroll table { margin-bottom: 0; }
.table-scroll thead th { position: sticky; top: 0; z-index: 2; }
.table-scroll::-webkit-scrollbar { width: 8px; }
.table-scroll::-webkit-scrollbar-thumb { background: var(--mint); border-radius: 8px; }
.table-scroll::-webkit-scrollbar-track { background: var(--mint-soft); }

/* 상단 선택 리스트(카테고리/상품/회원)는 좁게 — 본문 리스트에 자리를 양보 */
.table-scroll.table-scroll--compact { max-height: 200px; }

/* 발행쿠폰리스트 가독성 개선: 본문 인라인 font-size(small/smaller)를 덮어써서 글자를 키움 */
.table-scroll:not(.table-scroll--compact) td,
.table-scroll:not(.table-scroll--compact) th,
.table-scroll:not(.table-scroll--compact) span,
.table-scroll:not(.table-scroll--compact) .small,
.table-scroll:not(.table-scroll--compact) tr {
  font-size: 0.92rem !important;
  line-height: 1.55;
}
.table-scroll:not(.table-scroll--compact) td { padding: 9px 10px !important; }
.table-scroll:not(.table-scroll--compact) thead th { font-size: 0.95rem !important; padding: 10px !important; }
.table-scroll:not(.table-scroll--compact) td.text-start { font-weight: 600; }

/* ============ 상태 뱃지 ============ */
.badge-pill { display: inline-block; padding: 3px 12px; border-radius: 999px; font-size: 0.75rem; font-weight: 700; letter-spacing: .2px; }
.badge-mint { background: var(--mint-soft); color: var(--mint-deep); }
.badge-gray { background: #EEF1EF; color: var(--ink-soft); }
.badge-info { background: #E6F0FF; color: #3266CC; }

/* ============ 칩 (선택된 파라메타) ============ */
#stockTable .stockTable { border: 1px solid var(--card-border); border-radius: var(--radius-md); background: var(--card); padding: 4px; max-height: 90px; overflow-y: auto; }
#stockTable .chips-container { display: flex; flex-wrap: wrap; gap: 5px; min-height: 22px; padding: 3px; }
#stockTable .chip { background: var(--mint-soft); color: var(--mint-deep); border-radius: 999px; padding: 2px 10px 2px 12px; display: flex; align-items: center; font-size: 0.78rem; font-weight: 600; }
#stockTable td.stockTable:nth-child(2) .chip { background: var(--coral-soft); color: #C6441E; }
#stockTable .chip-close { background: none; border: none; margin-left: 6px; cursor: pointer; font-weight: bold; font-size: 1rem; color: inherit; opacity: .6; }
#stockTable .chip-close:hover { opacity: 1; color: var(--danger); }

/* ============ 레이어 팝업 (검색결과) ============ */
.data-layer {
  position: absolute;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius-md);
  color: var(--ink);
  padding: 18px;
  z-index: 1000;
  box-shadow: var(--shadow-md);
  border-top: 3px solid var(--coral);
}
.layer-content { position: relative; height: 100%; padding-top: 10px; overflow: auto; }
.close-btn { position: absolute; right: 0; top: -6px; background: none; border: none; color: var(--ink-soft); font-size: 20px; cursor: pointer; }
.close-btn:hover { color: var(--danger); }
.layerData { margin-top: 8px; text-align: left; font-size: 0.9em; word-break: keep-all; color: var(--ink); }

/* ============ 엑셀 업로드 모달 ============ */
.modal-overlay { position: fixed; inset: 0; background: rgba(30,43,36,0.45); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-box { background: var(--card); border-radius: var(--radius-lg); width: 480px; padding: 24px; box-shadow: var(--shadow-md); }
.modal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.modal-info { font-size: 0.95rem; color: var(--ink-soft); margin-bottom: 4px; }

.upload-area { border: 2px dashed var(--card-border); border-radius: var(--radius-md); padding: 40px 20px; text-align: center; cursor: pointer; transition: all .2s ease; background: var(--bg); margin-top: 12px; }
.upload-area.drag-over { border-color: var(--mint); background: var(--mint-soft); transform: scale(1.01); }
.upload-placeholder { display: flex; flex-direction: column; align-items: center; gap: 8px; color: var(--ink-soft); font-size: 14px; pointer-events: none; }
.upload-icon { font-size: 36px; }
.file-selected { display: flex; align-items: center; justify-content: center; gap: 12px; color: var(--mint-deep); font-weight: 700; }
.btn-file-clear { background: none; border: 1px solid var(--card-border); border-radius: 50%; width: 22px; height: 22px; cursor: pointer; font-size: 11px; color: var(--ink-soft); line-height: 1; }
.btn-file-clear:hover { border-color: var(--danger); color: var(--danger); }

.modal-footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px; }
.btn-cancel { padding: 8px 20px; border: 1px solid var(--card-border); border-radius: var(--radius-sm); background: #fff; cursor: pointer; }
.btn-upload { padding: 8px 20px; background: var(--mint); color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-weight: 700; }
.btn-upload:disabled { background: #CBD5CF; cursor: not-allowed; }
.btn-close { background: none; border: none; font-size: 18px; cursor: pointer; color: var(--ink-soft); }

@media (prefers-reduced-motion: reduce) {
  .coupon-page * { transition: none !important; }
}
</style>